import { ShopDto } from "@babackapp/private-api-client/types";

export function getReasonFromId(reasonId: string, shop: ShopDto) {
  return shop.reasons.find((reason) => reason.id === reasonId);
}
